import { render, staticRenderFns } from "./invite-parent.vue?vue&type=template&id=6022abd0&scoped=true"
import script from "./invite-parent.vue?vue&type=script&lang=js"
export * from "./invite-parent.vue?vue&type=script&lang=js"
import style0 from "./invite-parent.vue?vue&type=style&index=0&id=6022abd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022abd0",
  null
  
)

export default component.exports